import useCheckRole from "Hooks/APICheckRole";
import APIVoiceRegionProvider from "Providers/APIRegionProvider";
import React, { useState } from "react";
import { Container } from "semantic-ui-react";
import RegionView from "./Region/RegionView";

const ConfigView = () => {
  const [activeView, setActiveView] = useState("regions");
  const { hasRole, roles } = useCheckRole();
  const isRatingTable = hasRole(roles.config.region.roles.view);
  return (
    <Container fluid>
      {activeView === "regions" && isRatingTable && (
        <APIVoiceRegionProvider>
          <RegionView selectView={(value: string) => setActiveView(value)} />
        </APIVoiceRegionProvider>
      )}
    </Container>
  );
};

export default ConfigView;
